<script setup>
import Layout from "./Authenticated.vue";
import { Link, usePage } from "@inertiajs/inertia-vue3";
import { watch, onMounted, nextTick } from "vue";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";

const props = defineProps([
    'flash',
]);

const page = usePage();
</script>

<template>
    <Layout>
        <div class="lato max-w-7xl mx-auto p-4 my-10">
            <div class="text-xl font-bold mb-7">Management</div>
            <div class="flex gap-[3em] mx-auto pb-14">
                <nav class="max-w-[250px]">
                    <ul class="list-none p-0 m-0 space-y-4">
                        <li>
                            <Link href="/management/companies"
                                  :class="[
                                    'block transition-all duration-200',
                                    $page.url.startsWith('/management/companies') ? 'text-black font-bold' : 'text-gray-500 hover:text-black'
                                  ]">
                                Unternehmen
                            </Link>
                        </li>
                        <li>
                            <Link href="/management/providers"
                                  :class="[
                                    'block transition-all duration-200',
                                    $page.url.startsWith('/management/providers') ? 'text-black font-bold' : 'text-gray-500 hover:text-black'
                                  ]">
                                Mitarbeiter
                            </Link>
                        </li>
                        <li>
                            <Link href="/management/services"
                                  :class="[
                                    'block transition-all duration-200',
                                    $page.url.startsWith('/management/services') ? 'text-black font-bold' : 'text-gray-500 hover:text-black'
                                  ]">
                                Dienstleistungen
                            </Link>
                        </li>
                        <li>
                            <Link href="/management/service-categories"
                                  :class="[
                                    'block transition-all duration-200',
                                    $page.url.startsWith('/management/service-categories') ? 'text-black font-bold' : 'text-gray-500 hover:text-black'
                                  ]">
                                Dienstleistungskategorien
                            </Link>
                        </li>
                        <li>
                            <Link href="/management/devices"
                                  :class="[
                                    'block transition-all duration-200',
                                    $page.url.startsWith('/management/devices') ? 'text-black font-bold' : 'text-gray-500 hover:text-black'
                                  ]">
                                Geräte
                            </Link>
                        </li>
                        <li>
                            <Link href="/management/note-types"
                                  :class="[
                                    'block transition-all duration-200',
                                    $page.url.startsWith('/management/note-types') ? 'text-black font-bold' : 'text-gray-500 hover:text-black'
                                  ]">
                                Notiztypen
                            </Link>
                        </li>
                    </ul>
                </nav>

                <div class="flex-1">
                    <div class="bg-white rounded p-8">
                        <slot />
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
